var map = {
	"./social-500px.svg": 72,
	"./social-dribble.svg": 73,
	"./social-facebook.svg": 74,
	"./social-github.svg": 75,
	"./social-google.svg": 76,
	"./social-instagram.svg": 77,
	"./social-odnoklassniki.svg": 78,
	"./social-rediit.svg": 79,
	"./social-stackoverflow.svg": 80,
	"./social-steam.svg": 81,
	"./social-twitch.svg": 82,
	"./social-twitter.svg": 83,
	"./social-vkontakte.svg": 84,
	"./social-windows.svg": 85,
	"./social-yahoo.svg": 86
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars ^\.\/social\-.*\.svg$
// module id = 71
// module chunks = 0